
define(
    'jsx!components/viewbuncee-v3',[
        "react",
        "actions/viewbuncee",
        "shared/get-url-parameter",
        "shared/pendo"
    ], function (React, ViewBunceeActions, GetURLParameter, Pendo) {
        return React.createClass({
            actions: new ViewBunceeActions(),
            detectCreationRedirect: function(x) {
                /**
                 *  Since the iframe cannot redirect the host window, we will have to detect and redirects to
                 *  the creation canvas from here and redirect the browser ourselves.
                 */
                try {
                    const redirectLocation = x.target.contentWindow.location.href;
                    if (redirectLocation && redirectLocation.startsWith(window.appData.client.web_url)) {
                        window.location.href = redirectLocation;
                    }
                } catch (e) {
                   console.log(e);
                }
            },
            componentDidMount: function() {
                // For some reason embed views don't handle redirects properly so we will have to detect it using this method.
                if (document.getElementById("buncee-view-mobile")) {
                    document.getElementById("buncee-view-mobile").onload = this.detectCreationRedirect
                }
                
                /**
                 * Check for changes to the visualViewport height and sets the app window height to it accordingly
                 * Only needed for iPads/iPhone
                 */
                if (this.actions.getUserAgent().isIPhone() || this.actions.getUserAgent().isIPad()) {
                    if (this.actions.getUserAgent().isSafari() && this.actions.getUserAgent().getSafariVersion() >= 13) {
                        // Scroll up to make sure the header shows entirely 
                        $(window).scrollTop(-1);
                        var height = window.visualViewport.height;

                        // VisualViewport works better for detect screen changes, especially for hide/show toolbar
                        window.visualViewport.addEventListener('resize', function() {
                            resize();
                        });
                        
                        // Sets the app height to the height of window
                        var resize = function() {
                            // Don't change height if the user is pinch zooming
                            if (window.visualViewport.scale !== 1) {
                                return;
                            }
                            if(window.visualViewport.height != height) {
                                height = window.visualViewport.height;
                                $('#viewbuncee-container').css('height', height + 'px');
                                // Scroll up to make sure the header shows entirely 
                                $(window).scrollTop(-1);
                            }
                        }
                    } else if (this.actions.getUserAgent().isSafari()) {
                        // iOS12 and under does't support VisualViewport
                        $(window).scrollTop(-1);
                        var height = window.innerHeight;
                        window.addEventListener('resize', function() {
                            if(window.innerHeight != height) {
                                height = window.innerHeight;
                                $('#viewbuncee-container').css('height', height + 'px');
                                // Scroll up to make sure the header shows entirely 
                                $(window).scrollTop(-1);
                            }
                        });
                    }
                }
                var bunceeIframeElement = this.refs.viewbuncee.getDOMNode();

                /**
                 * 12/14/2020
                 * Tim
                 * Originally the bunceeURL for iframe content was configured in render() function below
                 * Couple reason why it was brought up here
                 * 1. In order to play any video, including Youtube, the iframe had to contain attribute "allow=autoplay"
                 * 2. This codebase react version is below 16 so above custom attribue like "allow=autoplay" was not allowed
                 * 3. Iframe content (the api player of buncee) does not reflect the attirbutes that were set after its loaded
                 * 4. Therefore, the iframe content had to be loaded after the custom attribute is injected
                 */
                var bunceeURL = window.appData.buncee.links.embed;
                var client = GetURLParameter.get('client');

                if(client) {
                    bunceeURL = window.appData.client.api_url + "/player/" + window.appData.buncee.data.guid + "?client=" + client;
                    if(window.appData.user) {
                        bunceeURL = bunceeURL + "&access_token=" + window.appData.user.access_token;
                    }
                }

                if (bunceeIframeElement) {
                    // Set the custom attribute to react node
                    bunceeIframeElement.setAttribute("allow", "autoplay;");
                    // Instead of reloading or resetting the src, set the buncee url once the custom attribute is injected, so the above attribute can apply to the loaded iframe content
                    bunceeIframeElement.src = bunceeURL
                }

                /**
                 * Initialize Pendo once preview page is mounted on DOM
                 * @author Dale Kelly
                 * @dateCreated 01/18/2021
                 */
                const pendo = window.pendo;
                const user = (window.appData.user) ? window.appData.user.data : null;
                if (pendo && user) {
                    Pendo.init(pendo);
                }
            },
            render: function () {

                var height = window.innerHeight;
                // Only Safari 13+ will use visualViewport
                if (this.actions.getUserAgent().isSafari()  && this.actions.getUserAgent().getSafariVersion() >= 13) {
                    height = window.visualViewport.height;
                }

                if (this.actions.getUserAgent().isMobile()) {
                    var bunceePlayer = React.createElement("iframe", {id: "buncee-view-mobile", ref: "viewbuncee", src: "", onLoad: this.detectCreationRedirect, scrolling: "no", allowFullScreen: true});
                    var id = "viewbuncee-body-mobile";
                } else {
                    var bunceePlayer = React.createElement("iframe", {id: "buncee-view", ref: "viewbuncee", src: "", width: "100%", height: "100%", onLoad: this.detectCreationRedirect, allowFullScreen: true});
                    var id = "viewbuncee-body";
                }
                return (
                    React.createElement("div", {id: "viewbuncee-container", style: {height: this.actions.getUserAgent().isMobileSafari() ? height+"px" : "100%"}}, 
                        React.createElement("div", {id: id}, 
                            bunceePlayer
                        )
                    )
                );
            }
        });
    }
);
